import {
  Box,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import PayForm from "components/PayForm";
import TraitTile from "components/TraitTile";
import { SwiperSlide } from "swiper/react/swiper-react";
import { Controller } from "swiper";
import ControlledSwiper from "components/ControlledSwiper";
import useTraitSales from "hooks/useTraitSales";

type PayPopupProps = Omit<ModalProps, "children"> & {
  newTraits: number[];
  tokenId: number;
  color: number;
};

const PayPopup = ({ tokenId, newTraits, color, ...rest }: PayPopupProps) => {
  const translate = useTranslate();
  const { traitSalesMap } = useTraitSales();
  const isMultiple = newTraits.length > 1;

  const slidesPerView = isMultiple ? 1.35 : 1;

  return traitSalesMap ? (
    <Modal {...rest}>
      <ModalOverlay />
      <ModalContent w="sm" maxH="calc(100vh - 2rem)" mt="0" mb="0">
        <ModalCloseButton />

        <ModalBody
          py="8"
          px="0"
          display="flex"
          flexDir="column"
          maxH="full"
          overflow="auto"
        >
          <VStack pt="4" pb="3" w="full" spacing="6" align="stretch">
            <Box px="12">
              <Heading
                fontSize="2xl"
                fontWeight="bold"
                textAlign="center"
                mb="3"
              >
                {translate(
                  isMultiple ? "pay:title:multi" : "pay:title:single",
                  { count: newTraits.length }
                )}
              </Heading>

              <Text fontSize="sm" opacity="0.8" textAlign="center">
                {translate("pay:description")}
              </Text>
            </Box>

            <ControlledSwiper
              spaceBetween={2}
              threshold={10}
              modules={[Controller]}
              slidesPerView={slidesPerView}
              freeMode
            >
              {newTraits.map((tokenId) => (
                <SwiperSlide key={tokenId}>
                  <TraitTile
                    tokenId={tokenId}
                    price={traitSalesMap[tokenId].price}
                    color={color}
                    px="6"
                    w="full"
                    canvasSize="12"
                    bg="dark.600"
                  />
                </SwiperSlide>
              ))}
            </ControlledSwiper>
          </VStack>

          <PayForm tokenId={tokenId} newTraits={newTraits} />
        </ModalBody>
      </ModalContent>
    </Modal>
  ) : null;
};

export default PayPopup;
